import { render, staticRenderFns } from "./ModalMsgDealer.vue?vue&type=template&id=3e85d3b2&"
import script from "./ModalMsgDealer.vue?vue&type=script&lang=js&"
export * from "./ModalMsgDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports